export default {
    getPlayer(state) {
        return state.player;
    }
}